export const environment = {
    "reCAPTCHA": {
        "PublicKey": "6Ld8WOMUAAAAAMfovvW_g9NuFmqn_f8Q1loj06UV"
    },
    apiUrl: 'https://mainapi.tiravto.com',
    storeImageUrl: '/images/stores/',
    productImageUrl: 'https://storage.tiravto.com/image/tiravto-storage/images/',
    productFileUrl: 'https://storage.tiravto.com/file/tiravto-storage/',
    storageUrl: 'https://storage.tiravto.com',
    categoryImageUrl: '/images/categories/',
    noPhotoUrl: '/image/tiravto-storage/images/BE2CABE171354FB73E6734AD29ED0F8B',

}

